module.exports = __webpack_public_path__ + "static/media/danny.8efcf63d.JPG";